'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayProcessingScreenForMinimumTime = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.onPerformComplete3DS = onPerformComplete3DS;
exports.perform3dsDepositV2 = perform3dsDepositV2;
exports.performInit3DS = performInit3DS;
exports.onPerformInit3DS = onPerformInit3DS;
exports.watchPerformInit3DS = watchPerformInit3DS;
exports.watchPerformComplete3DS = watchPerformComplete3DS;

var _messageBus = require('@wh/message-bus');

var _effects = require('redux-saga/effects');

var _reduxSaga = require('redux-saga');

var _quickDepositLogic = require('@wh/quick-deposit-logic');

var _actions = require('../../actions');

var _selectors = require('../../selectors');

var _events = require('../../events');

var _analytics = require('../../analytics');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(makeDepositSuccess),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(makeDepositError),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handlePaymentResponse),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(onPerformComplete3DS),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(startChallenge),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(perform3dsDepositV2),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(performInit3DS),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(onPerformInit3DS),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(watchPerformInit3DS),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(watchPerformComplete3DS);
//compatibility to versions up to 0.15 of redux-sage


var takeEveryEffect = _effects.takeEvery || _reduxSaga.takeEvery;

/**
 * counter triggers concurrently with Frictionless Request, makes sure processing screen is being displayed for 2 secs
 * @returns {Promise} - Promise
 */
var displayProcessingScreenForMinimumTime = exports.displayProcessingScreenForMinimumTime = function displayProcessingScreenForMinimumTime() {
  return new _promise2.default(function (resolve) {
    setTimeout(function () {
      resolve();
    }, _constants.REQUIRED_MINIMUM_TIME_FOR_DISPLAYING_SPINNER_MS);
  });
};

/**
 * makeDepositSuccess
 * @param {DepositResponseType} depositResult Deposit result from Payment API service
 * @param {Object} activeDepositData active deposit data
 * @param {Object} trackingData tracking data
 * @returns {void}
 */
function makeDepositSuccess(depositResult, activeDepositData, trackingData) {
  var initData;
  return _regenerator2.default.wrap(function makeDepositSuccess$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _actions.performDepositSucceded)(depositResult));

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _actions.trackEvent)(_analytics.MESSAGE_TRACKING_QD_SUCCESSFUL, {
            EffortAttempt: trackingData.submitCount.toString(),
            DepositAmount: activeDepositData.amount
          }));

        case 4:
          _context.next = 6;
          return (0, _effects.select)(_selectors.initDataSelector);

        case 6:
          initData = _context.sent;

          if (!initData.closeOnSuccess) {
            _context.next = 10;
            break;
          }

          _context.next = 10;
          return (0, _effects.put)((0, _actions.closingComponent)());

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/**
 * makeDepositError
 *  @param {Number} submitCount count
 *  @param {Error} error object
 *  @param {String} responseStatus message string
 *  @param {String} amount string
 * @returns {void}
 */
function makeDepositError(submitCount, error, responseStatus, amount) {
  return _regenerator2.default.wrap(function makeDepositError$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _actions.performDepositFailed)(error));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)((0, _actions.trackEvent)(_analytics.MESSAGE_TRACKING_QD_UNSUCCESSFUL, {
            EffortAttempt: submitCount.toString(),
            ErrorFields: _analytics.GENERIC_ERROR_FIELD_IDENTIFIER,
            ErrorFieldsAmount: '1',
            ErrorMessages: error ? error.message : responseStatus,
            ErrorCode: error && error.code || responseStatus || null,
            DepositAmount: amount
          }));

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/**
 * Fetch handlePaymentResponse Saga
 * @param {DepositResponseType} depositResult - result of 3DS payment
 * @param {Object} activeDepositData - active deposit data
 * @param {Object} trackingData - tracking data
 * @returns {void}
 */
function handlePaymentResponse(depositResult, activeDepositData, trackingData) {
  return _regenerator2.default.wrap(function handlePaymentResponse$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!(depositResult.status === _constants.OB_PMT_API_STATUS_SUCCESS)) {
            _context3.next = 4;
            break;
          }

          return _context3.delegateYield(makeDepositSuccess(depositResult, activeDepositData, trackingData), 't0', 2);

        case 2:
          _context3.next = 5;
          break;

        case 4:
          return _context3.delegateYield(makeDepositError(trackingData.submitCount, undefined, depositResult.status, activeDepositData.amount), 't1', 5);

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/**
 * Fetch onPerformComplete3DS Saga
 * @param {Object} data - received from challenge Iframe
 * @param {String} threeDSVersion - version od 3ds
 * @returns {void}
 */
function onPerformComplete3DS(_ref, threeDSVersion) {
  var data = _ref.data;
  var trackingData, activeDepositData, depositApi, depositResult;
  return _regenerator2.default.wrap(function onPerformComplete3DS$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(_selectors.trackingDataSelector);

        case 2:
          trackingData = _context4.sent;
          _context4.next = 5;
          return (0, _effects.select)(_selectors.activeDepositDataSelector);

        case 5:
          activeDepositData = _context4.sent;
          _context4.prev = 6;
          depositApi = threeDSVersion === _constants.QD_3DS_V2 ? (0, _quickDepositLogic.secure3dDepositAPIv2)() : (0, _quickDepositLogic.secure3dDepositAPI)();
          _context4.next = 10;
          return (0, _effects.call)(function () {
            return depositApi.complete3DSPayment(activeDepositData, data);
          });

        case 10:
          depositResult = _context4.sent;
          return _context4.delegateYield(handlePaymentResponse(depositResult, activeDepositData, trackingData), 't0', 12);

        case 12:
          _context4.next = 17;
          break;

        case 14:
          _context4.prev = 14;
          _context4.t1 = _context4['catch'](6);
          return _context4.delegateYield(makeDepositError(trackingData.submitCount, _context4.t1, undefined, activeDepositData.amount), 't2', 17);

        case 17:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[6, 14]]);
}

/**
 * Fetch onPerformComplete3DS Saga
 * @param {FrictionlessResponseType} frictionlessResponse response from frictionlessRequest
 * @returns {void}
 */
function startChallenge(frictionlessResponse) {
  var creq, acsUrl, threeDSSessionData, depositApi, challengeResponse;
  return _regenerator2.default.wrap(function startChallenge$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          creq = frictionlessResponse.creq, acsUrl = frictionlessResponse.acsUrl, threeDSSessionData = frictionlessResponse.threeDSSessionData;
          depositApi = (0, _quickDepositLogic.secure3dDepositAPIv2)();
          _context5.next = 4;
          return (0, _effects.call)(function () {
            return depositApi.startChallenge(creq, acsUrl, threeDSSessionData);
          });

        case 4:
          challengeResponse = _context5.sent;


          depositApi.removeChallengeIframe();
          return _context5.delegateYield(onPerformComplete3DS({ data: challengeResponse }, _constants.QD_3DS_V2), 't0', 7);

        case 7:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

/**
 * Get additional parameters for nuveri gateway, skip for different gateways
 * @param {String} threeDSVersion - version of 3DSECURE, current support 2.1.0
 * @param {String} threeDSMethodData - base64 code for fingerprint redirection
 * @param {String} threeDSv2RedirectURL - redirection url address
 * @returns {Object}
 *
 * Return specific value based on passed parameters for 3DS fingerprinting
 * U - the fingerprinting fields from previous response were blank: threeDSv2RedirectURL or threeDSMethodData
 * Y - the fingerprinting returned back to site within 10 seconds
 * N - the fingerprinting did not return within 10 seconds
 *
 * TODO: implement logic for N value of methodCompletionInd
 */
function getNuveiParameters(threeDSVersion, threeDSMethodData, threeDSv2RedirectURL) {
  // Check if gateway is nuvei, only for this case threeDSVersion is equal 2.1.0
  if (!threeDSVersion) {
    return {};
  }

  // threeDSMethodData is base64 code which can be decoded and used for some specific cases
  // threeDSv2RedirectURL is always configured but anyway nice to check it again
  if (threeDSMethodData && threeDSv2RedirectURL) {
    return {
      threeDSVersion: threeDSVersion,
      methodCompletionInd: 'Y'
    };
  }

  return {
    threeDSVersion: threeDSVersion,
    methodCompletionInd: 'U'
  };
}

/**
 * Fetch onPerformComplete3DS Saga
 * @param {TdsDetailsType} cardId Card Id
 * @param {DepositResponseType} depositResult Deposit result from Payment API service
 * @param {String} tdsTermUrl defined in config, url to EPG
 * @returns {void}
 */
function perform3dsDepositV2(cardId, depositResult, tdsTermUrl) {
  var txnId, MD, pmtId, depositStatus, threeDSMethodData, threeDSv2RedirectURL, threeDSv2Token, threeDSVersion, trackingData, depositApi, _getNuveiParameters, methodCompletionInd, _ref2, _ref3, frictionlessResponse, status, activeDepositData;

  return _regenerator2.default.wrap(function perform3dsDepositV2$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          txnId = depositResult.gatewayTransactionId, MD = depositResult.MD, pmtId = depositResult.pmtId, depositStatus = depositResult.status, threeDSMethodData = depositResult.threeDSMethodData, threeDSv2RedirectURL = depositResult.threeDSv2RedirectURL, threeDSv2Token = depositResult.threeDSv2Token, threeDSVersion = depositResult.threeDSVersion;
          _context6.next = 3;
          return (0, _effects.select)(_selectors.trackingDataSelector);

        case 3:
          trackingData = _context6.sent;
          depositApi = (0, _quickDepositLogic.secure3dDepositAPIv2)();
          _context6.prev = 5;

          depositApi.createFrictionlessIframe(threeDSMethodData, threeDSv2RedirectURL);
          _getNuveiParameters = getNuveiParameters(threeDSVersion, threeDSMethodData, threeDSv2RedirectURL), methodCompletionInd = _getNuveiParameters.methodCompletionInd;
          _context6.next = 10;
          return (0, _effects.all)([(0, _effects.call)(function () {
            return depositApi.frictionlessRequest(cardId, pmtId, threeDSv2Token, txnId, MD, tdsTermUrl, threeDSVersion, methodCompletionInd);
          }), (0, _effects.call)(function () {
            return displayProcessingScreenForMinimumTime();
          })]);

        case 10:
          _ref2 = _context6.sent;
          _ref3 = (0, _slicedToArray3.default)(_ref2, 1);
          frictionlessResponse = _ref3[0];

          depositApi.removeFrictionlessIframe();
          status = frictionlessResponse.status;
          _context6.next = 17;
          return (0, _effects.select)(_selectors.activeDepositDataSelector);

        case 17:
          activeDepositData = _context6.sent;

          if (!(status === _constants.OB_PMT_API_STATUS_SUCCESS)) {
            _context6.next = 22;
            break;
          }

          return _context6.delegateYield(makeDepositSuccess(frictionlessResponse, activeDepositData, trackingData), 't0', 20);

        case 20:
          _context6.next = 27;
          break;

        case 22:
          if (!(status === _constants.OB_PMT_API_STATUS_CHALLENGE_REQUIRED)) {
            _context6.next = 26;
            break;
          }

          return _context6.delegateYield(startChallenge(frictionlessResponse, trackingData), 't1', 24);

        case 24:
          _context6.next = 27;
          break;

        case 26:
          return _context6.delegateYield(makeDepositError(trackingData.submitCount, undefined, status, activeDepositData.amount), 't2', 27);

        case 27:
          _context6.next = 33;
          break;

        case 29:
          _context6.prev = 29;
          _context6.t3 = _context6['catch'](5);
          return _context6.delegateYield(makeDepositError(trackingData.submitCount, _context6.t3, depositStatus), 't4', 32);

        case 32:
          depositApi.removeChallengeIframe();

        case 33:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[5, 29]]);
}

/**
 * Activate 3DS journey
 * @param {Object} depositDataObj Initial deposit data
 * @param {DepositResponseType} depositResult Deposit result from Payment API service
 * @returns {void}
 */
function performInit3DS(depositDataObj, depositResult) {
  var isThreeDSV2, _ref4, tdsTermUrl, tdsTermUrlV2, depositApi, init3dsData, trackingData;

  return _regenerator2.default.wrap(function performInit3DS$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          isThreeDSV2 = depositResult.status === _constants.OB_PMT_API_STATUS_AWAITING3DS_V2;
          _context7.next = 4;
          return (0, _effects.select)(_selectors.configSelector);

        case 4:
          _ref4 = _context7.sent;
          tdsTermUrl = _ref4.tdsTermUrl;
          tdsTermUrlV2 = _ref4.tdsTermUrlV2;

          if (!isThreeDSV2) {
            _context7.next = 13;
            break;
          }

          _context7.next = 10;
          return (0, _effects.put)((0, _actions.init3DSv2)(depositResult));

        case 10:
          return _context7.delegateYield(perform3dsDepositV2(depositDataObj.cardId, depositResult, tdsTermUrlV2), 't0', 11);

        case 11:
          _context7.next = 19;
          break;

        case 13:
          depositApi = (0, _quickDepositLogic.secure3dDepositAPI)();
          _context7.next = 16;
          return (0, _effects.call)(function () {
            return depositApi.get3DDetails(depositDataObj.cardId, depositResult, tdsTermUrl);
          });

        case 16:
          init3dsData = _context7.sent;
          _context7.next = 19;
          return (0, _effects.put)((0, _actions.init3DS)(init3dsData));

        case 19:
          _context7.next = 27;
          break;

        case 21:
          _context7.prev = 21;
          _context7.t1 = _context7['catch'](0);
          _context7.next = 25;
          return (0, _effects.select)(_selectors.trackingDataSelector);

        case 25:
          trackingData = _context7.sent;
          return _context7.delegateYield(makeDepositError(trackingData.submitCount, _context7.t1, depositResult.status), 't2', 27);

        case 27:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this, [[0, 21]]);
}

/**
 * Publish an event notifying that the 3DS journey was activated
 * @returns {void}
 */
function onPerformInit3DS() {
  return _regenerator2.default.wrap(function onPerformInit3DS$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _messageBus.publish)(_events.MESSAGE_PUB_QD_INIT3DS, {});

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

/**
 * Fetch watchPerformInit3DS Saga
 * @returns {void}
 */
function watchPerformInit3DS() {
  return _regenerator2.default.wrap(function watchPerformInit3DS$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return takeEveryEffect([_constants.QD_ACTION_INIT3DS, _constants.QD_ACTION_INIT3DS_V2], onPerformInit3DS);

        case 2:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

/**
 * Fetch watchPerformComplete3DS Saga
 * @returns {void}
 */
function watchPerformComplete3DS() {
  return _regenerator2.default.wrap(function watchPerformComplete3DS$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_COMPLETE3DS, onPerformComplete3DS);

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}